import React, {Fragment} from "react";
import PropTypes from "prop-types";
import {Card, CardHeader, Row, ListGroup, ListGroupItem} from "reactstrap";
import "./leftnav.scss";

const LeftNav = (props) => {
  const {
    navList,
    title,
    selectedIndex,
    onClickHandle = () => {},
    ...relativePops
  } = props;

  return (
    <Fragment>
      <Card className="shadow">
        <CardHeader className="border-0">
          <Row className="align-items-center">
            <div className="col">
              <h3 className="mb-0">{title}</h3>
            </div>
            <div className="col text-right"></div>
          </Row>
        </CardHeader>
        <ListGroup>
          {navList &&
            navList.length > 0 &&
            navList.map((nav, index) => {
              const isActive = selectedIndex === index;
              return (
                <ListGroupItem
                  className={`leftnav-item ${isActive ? "active-leftnav-item" : ""}`}
                  key={`nav_${index}`}
                  action
                  tag="a"
                  active={isActive}
                  disabled={isActive}
                  onClickCapture={() => {
                    onClickHandle(index, nav);
                  }}
                  {...relativePops}
                >
                  {nav}
                </ListGroupItem>
              );
            })}
        </ListGroup>
      </Card>
    </Fragment>
  );
};

LeftNav.propTypes = {
  navList: PropTypes.arrayOf(PropTypes.string).isRequired,
  title: PropTypes.string,
  selectedIndex: PropTypes.number,
  onClickHandle: PropTypes.func,
};

export default LeftNav;
